import { render, staticRenderFns } from "./PhotoGallery.vue?vue&type=template&id=452e857d&scoped=true"
import script from "./PhotoGallery.vue?vue&type=script&lang=js"
export * from "./PhotoGallery.vue?vue&type=script&lang=js"
import style0 from "./PhotoGallery.vue?vue&type=style&index=0&id=452e857d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e857d",
  null
  
)

export default component.exports